/*
 * AddEditSpace Messages
 *
 * This contains all the text for the AddEditSpace component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.AddEditSpace';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  subscription: {
    id: `${scope}.subscription`,
    defaultMessage: 'Subscription',
  },
  spaceOwnerAdmins: {
    id: `${scope}.spaceOwnerAdmins`,
    defaultMessage: 'Space Owner and Administrators',
  },
  spaceOwner: {
    id: `${scope}.spaceOwner`,
    defaultMessage: 'Space Owner',
  },
});
